export const POSTS = [
  {
    slug: "quanto-cobrar-visita-tecnica",
    title: "Como calcular quanto cobrar por uma visita técnica",
    excerpt: "Deslocamento, tempo, diagnóstico e o erro de cobrar barato demais para 'só dar uma olhada'.",
    date: "2026-06-01",
    content: [
      "A visita técnica parece simples, mas esconde custos: combustível, tempo de trânsito, ferramentas e o seu conhecimento de diagnóstico. Cobrar 'só R$ 50' quase sempre significa prejuízo disfarçado.",
      "Comece calculando seu custo de deslocamento: quilômetros totais (ida e volta) × custo por km do seu veículo (combustível + depreciação + manutenção). Um valor comum no Brasil fica entre R$ 1,50 e R$ 3,00 por km.",
      "Depois some o tempo: quantas horas a visita consome, incluindo deslocamento? Multiplique pelo valor da sua hora técnica (veja nosso artigo sobre hora técnica).",
      "Por fim, defina um valor mínimo de visita. Ele protege você em chamados curtos e sinaliza profissionalismo. Muitos técnicos abatem a visita do serviço aprovado — uma ótima estratégia comercial que não gera prejuízo quando o mínimo foi bem calculado.",
      "No GEPR, tudo isso entra automaticamente no cálculo: km, hora técnica e valor mínimo de serviço já saem no orçamento.",
    ],
  },
  {
    slug: "como-calcular-hora-tecnica",
    title: "Como calcular a hora técnica de refrigeração",
    excerpt: "Salário alvo, custos fixos, horas produtivas reais e margem: a fórmula completa.",
    date: "2026-06-01",
    content: [
      "Sua hora técnica não é 'quanto quero ganhar por hora'. Ela precisa cobrir salário, custos fixos (seguro, ferramentas, telefone, contabilidade, impostos) e ainda gerar margem.",
      "Primeiro, some sua remuneração mensal alvo com todos os custos fixos mensais do negócio.",
      "Depois, estime suas horas produtivas reais: nem toda hora do mês é faturável. Desloque-se, faça orçamentos, responda clientes. Em geral, 60-70% das horas são produtivas.",
      "Divida: (salário alvo + custos fixos) ÷ horas produtivas = custo da sua hora.",
      "Por fim, aplique a margem: preço da hora = custo da hora ÷ (1 − margem). Com margem de 30%, uma hora que custa R$ 60 deve ser vendida a ~R$ 86.",
      "Use a ferramenta 'Custo da hora técnica' no GEPR para fazer essa conta em segundos.",
    ],
  },
  {
    slug: "como-calcular-deslocamento",
    title: "Como calcular deslocamento sem perder dinheiro",
    excerpt: "Km ida e volta, depreciação do veículo e o valor mínimo que protege seu dia.",
    date: "2026-06-01",
    content: [
      "O erro mais comum é cobrar só o combustível. Um veículo de trabalho custa combustível + pneus + óleo + manutenção + seguro + depreciação.",
      "Uma referência prática: divida o custo anual do veículo pelos quilômetros rodados a trabalho. Muitos técnicos chegam a R$ 1,80–R$ 3,00/km.",
      "Sempre calcule ida e volta — e considere retornos para segunda visita quando aplicável.",
      "Defina um deslocamento mínimo: atendimentos curtos e próximos também consomem tempo de agenda.",
      "No GEPR, o deslocamento entra separado no orçamento e o sistema aplica automaticamente o seu valor mínimo configurado.",
    ],
  },
  {
    slug: "markup-vs-margem",
    title: "Markup x margem de lucro: a diferença que quebra empresas",
    excerpt: "50% de markup não é 50% de margem. Entenda de uma vez por todas.",
    date: "2026-06-01",
    content: [
      "Markup é o percentual aplicado SOBRE o custo. Margem é o percentual do lucro SOBRE o preço de venda. Parecem iguais, mas não são.",
      "Exemplo: custo de R$ 100 com markup de 50% → preço de R$ 150. Sua margem real é 33% (50 ÷ 150), não 50%.",
      "Se você quer 50% de margem de verdade, o preço deve ser custo ÷ (1 − 0,50) = R$ 200.",
      "Essa confusão faz muitos técnicos cobrarem menos do que imaginam. Uma diferença de 17 pontos percentuais por serviço, ao longo de um mês, é o preço de várias ferramentas.",
      "O GEPR calcula por margem real e mostra o lucro estimado de cada orçamento antes de você enviar.",
    ],
  },
  {
    slug: "como-fazer-orcamento-refrigeracao",
    title: "Como fazer orçamento de refrigeração profissional",
    excerpt: "Estrutura, validade, garantia e condições: o que um orçamento sério precisa ter.",
    date: "2026-06-01",
    content: [
      "Um orçamento profissional transmite confiança e reduz negociação por preço. Ele precisa ter: dados da sua empresa, dados do cliente, equipamento, escopo do serviço, peças, valores, prazo, validade, garantia e condições de pagamento.",
      "Detalhe o escopo: 'troca de capacitor' é diferente de 'manutenção geral'. Escopo claro evita discussão depois.",
      "Sempre informe validade (7 a 15 dias é comum) — preços de peças e refrigerante mudam rápido.",
      "Condições de pagamento por escrito: entrada, parcelas, forma. 'Combinado por mensagem' vira problema.",
      "Com o GEPR, o orçamento sai em PDF com a sua marca em menos de 2 minutos, direto no WhatsApp do cliente.",
    ],
  },
  {
    slug: "cobrar-manutencao-camara-fria",
    title: "Como cobrar manutenção de câmara fria",
    excerpt: "Preventiva programada, contratos e o valor de evitar o prejuízo do cliente.",
    date: "2026-06-01",
    content: [
      "Câmara fria parada é mercadoria perdida — o cliente sabe disso. Precifique pelo valor que você entrega: disponibilidade e prevenção de perdas.",
      "Para preventivas, monte um checklist padrão (limpeza de condensador, verificação de gás, drenos, portas, controlador) e precifique por hora estimada + deslocamento.",
      "Contratos mensais de manutenção são o melhor modelo: receita recorrente para você, prioridade para o cliente.",
      "Na corretiva, considere adicional de urgência — atender fora de hora tem custo e valor.",
      "Use os alertas de manutenção preventiva do GEPR para nunca esquecer um retorno e manter o contrato ativo.",
    ],
  },
  {
    slug: "evitar-prejuizo-manutencao",
    title: "Como evitar prejuízo em serviços de manutenção",
    excerpt: "Os 5 vazamentos de dinheiro mais comuns e como fechar cada um.",
    date: "2026-06-01",
    content: [
      "Vazamento 1: esquecer custos — pedágio, estacionamento, ajudante, aluguel de ferramenta. Some tudo em 'outros custos'.",
      "Vazamento 2: peças pelo preço de custo. Peça tem margem própria — você compra, transporta e garante.",
      "Vazamento 3: desconto sem limite. Defina um teto de desconto e respeite.",
      "Vazamento 4: retrabalho sem cobrança. Garantia cobre defeito do serviço, não problema novo — deixe isso claro no orçamento.",
      "Vazamento 5: impostos esquecidos. MEI, Simples ou nota avulsa: o imposto sai do SEU bolso se não entrar no preço.",
      "O motor de precificação do GEPR fecha esses cinco pontos automaticamente e ainda avisa quando o preço ficar abaixo do custo.",
    ],
  },
  {
    slug: "como-criar-ordem-de-servico",
    title: "Como criar uma ordem de serviço organizada",
    excerpt: "OS é proteção jurídica e profissionalismo — veja o que não pode faltar.",
    date: "2026-06-01",
    content: [
      "A OS registra o que foi combinado e executado: cliente, equipamento, problema relatado, diagnóstico, serviço realizado, peças utilizadas, garantia e valor.",
      "Anote o número de série do equipamento — isso evita troca de responsabilidade por equipamento errado.",
      "Registre o problema relatado com as palavras do cliente. Se depois aparecer outro defeito, você tem o histórico.",
      "Assinatura do cliente na conclusão é sua maior proteção contra contestação.",
      "No GEPR, a OS sai em PDF com campos de assinatura, e fica vinculada ao cliente e ao equipamento para sempre.",
    ],
  },
  {
    slug: "profissionalizar-empresa-refrigeracao",
    title: "Como aumentar o profissionalismo da sua empresa de refrigeração",
    excerpt: "Pequenas mudanças de imagem e processo que justificam preços maiores.",
    date: "2026-06-01",
    content: [
      "Clientes pagam mais quando confiam mais. E confiança vem de processo: orçamento documentado, prazo cumprido, OS assinada, garantia por escrito.",
      "Padronize: mesmo orçamento, mesmas condições, mesma apresentação — para todo cliente.",
      "Tenha histórico: saber o que já foi feito em cada equipamento impressiona e vende preventiva.",
      "Apareça: um perfil público com cidade, especialidades e WhatsApp facilita o boca-a-boca digital.",
      "O GEPR junta tudo isso: orçamento profissional, CRM de clientes, histórico de equipamentos e diretório público opcional.",
    ],
  },
  {
    slug: "erros-formacao-de-preco",
    title: "Erros comuns na formação de preço de serviços técnicos",
    excerpt: "Do 'preço do concorrente' à margem imaginária: o que evitar.",
    date: "2026-06-01",
    content: [
      "Erro 1: copiar o preço do concorrente sem saber seus próprios custos. O custo dele não é o seu.",
      "Erro 2: calcular margem sobre o custo achando que é margem sobre o preço (veja nosso artigo markup x margem).",
      "Erro 3: não reajustar. Peças, combustível e refrigerante sobem — seu preço precisa acompanhar.",
      "Erro 4: dar desconto no lucro, não no preço. Se o desconto sair da margem, ele precisa estar previsto.",
      "Erro 5: ignorar referências de mercado. Saber a faixa praticada na sua região ajuda a posicionar seu preço — sem abrir mão dos seus custos.",
      "Com o GEPR, você calcula pelo seu custo real e ainda consulta a referência regional agregada quando quiser.",
    ],
  },
];
